<template>
  <div class="section  content is-size-7">
    <Header class="is-uppercase has-text-weight-bold" />
    <p class="is-size-6 has-text-centered">Cancelación realizada</p>
    <p class="has-text-centered">Te confirmamos que acabas de darte debaja de  Muscle Heroes. Puedes volver a disfrutar del servicio en culaquier monento entrando en http://es.muscle-heroes.com</p>
    <p class="has-text-centered"><router-link class="button has-text-white has-background-primary" :to="{ name: 'Home' }">Aceptar</router-link></p>
    <Footer class="is-uppercase has-text-weight-bold" />
  </div>
</template>


<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  name: 'DeactivationSuccess',
  components: {
    Header,
    Footer
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Pages/DeactivationSuccess.vue